import { useQuery } from "@tanstack/react-query";
import { createStudyGroupQuery } from "@/lib/queries/studyGroupQueries";

export const useStudyGroupInfo = (id: string | number | null) => {
  const {
    data: studyGroupInfo,
    isLoading,
    error: queryError,
    refetch,
  } = useQuery(createStudyGroupQuery(id));

  return {
    studyGroupInfo: studyGroupInfo || null,
    isLoading,
    error: queryError ?? null,
    errorMessage: queryError instanceof Error ? queryError.message : null,
    refetch,
  };
};
